// src/components/WarehouseQueue/WarehouseQueue.jsx
import React, { useState, useEffect } from 'react';

// import Header from '../components/Header';
import Card from '../components/Card';
import { RiRefreshLine, RiLoaderLine } from 'react-icons/ri';
import './WarehouseQueue.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../utils/constants';


const WarehouseQueue = () => {

  const navigateto = useNavigate();
  const [queueItems, setQueueItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchQueue = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${BASE_URL}/api/orders`);
      if (!response.ok) throw new Error(`Failed: ${response.status}`);

      const data = await response.json();

      // Filter to warehouse-ready orders (pending payment success or processing, not shipped/delivered)
      const pending = data.filter(order => 
        (order.paymentStatus === 'successful' || order.paymentStatus === 'pending') &&
        ['pending', 'processing'].includes(order.deliveryStatus)
      );

      // Sort by creation time (oldest first for queue)
      const sorted = pending.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

      setQueueItems(sorted);
    } catch (err) {
      console.error('Queue fetch error:', err);
      setError('Unable to load warehouse queue.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueue();
  }, []);

  const handleRefresh = () => {
    fetchQueue();
  };

  // const handleStartFulfillment = (order) => {
  //   // TODO: PATCH to mark as processing or start fulfillment
  //   alert(`Starting fulfillment for order ${order.reference}`);
  //   // Example future call:
  //   // fetch(`/api/orders/${order.reference}/fulfillment`, { method: 'PATCH', body: JSON.stringify({ status: 'processing' }) })
  // };

  const getTimeAgo = (date) => {
    const now = new Date();
    const diffMs = now - new Date(date);
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 60) return `${diffMins} minutes ago`;
    if (diffMins < 1440) return `${Math.floor(diffMins / 60)} hours ago`;
    return `${Math.floor(diffMins / 1440)} days ago`;
  };

  if (loading) {
    return (
      <div className="warehouse-queue-page">
        {/* <Header /> */}
        <div className="loading">
          <RiLoaderLine className="spin" size={32} /> Loading queue...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="warehouse-queue-page">
        {/* <Header /> */}
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="warehouse-queue-page">
      {/* <Header /> */}

      <main className="main-content">
        <div className="container">
          <div className="page-header">
            <div className="page-title-area">
              <h1 className="page-title">Warehouse Queue</h1>
            </div>
            <button className="refresh-button" onClick={handleRefresh}>
              <RiRefreshLine size={18} className="refresh-icon" />
              Refresh
            </button>
          </div>

          {queueItems.length === 0 ? (
            <div className="empty-state">
              No orders currently in queue. All caught up!
            </div>
          ) : (
            <div className="queue-list">
              {queueItems.map((item) => (
                <Card key={item.reference} className="queue-card">
                  <div className="queue-card-content">
                    <div className="queue-info">
                      <div className="order-id-row">
                        <h3 className="order-id">{item.reference}</h3>
                        <span className={`priority-badge ${item.deliveryStatus}`}>
                          {item.deliveryStatus.charAt(0).toUpperCase() + item.deliveryStatus.slice(1)}
                        </span>
                        {/* Optional tag - add logic later */}
                        {item.items.length > 5 && (
                          <span className="tag-badge">High Volume</span>
                        )}
                      </div>

                      <div className="meta-line">
                        <span className="icon-label">👤</span>
                        <span>{item.accountName || item.deliveryAddress?.fullName || 'Unknown'}</span>
                      </div>
                      <div className="meta-line">
                        <span className="icon-label">📦</span>
                        <span>{item.items.length} items</span>
                      </div>
                      <div className="meta-line">
                        <span className="icon-label">🕒</span>
                        <span className="time-ago">{getTimeAgo(item.createdAt)}</span>
                      </div>
                    </div>

                    <button
                      className="start-fulfillment-btn"
                      onClick={() => navigateto(`/dashboard/fulfill-order/${item.reference}`)}
                      // onClick={() => handleStartFulfillment(item)}
                    >
                      Start Fulfillment
                    </button>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default WarehouseQueue;

// import React from 'react';
// import Header from '../components/Header';
// import Card from '../components/Card';
// import { RiRefreshLine } from 'react-icons/ri';
// import './WarehouseQueue.css';

// const mockQueueItems = [
//   {
//     id: '#WH-2024-001284',
//     priority: 'NORMAL',
//     tag: 'Express',
//     customer: 'Lisa Wang',
//     items: 9,
//     timeAgo: '4 hours ago',
//     urgent: false,
//   },
//   {
//     id: '#WH-2024-001289',
//     priority: 'URGENT',
//     tag: null,
//     customer: 'Michael Chen',
//     items: 14,
//     timeAgo: '1 hour ago',
//     urgent: true,
//   },
//   {
//     id: '#WH-2024-001301',
//     priority: 'NORMAL',
//     tag: null,
//     customer: 'Sarah Johnson',
//     items: 5,
//     timeAgo: '2 hours ago',
//     urgent: false,
//   },
//   {
//     id: '#WH-2024-001315',
//     priority: 'NORMAL',
//     tag: 'Express',
//     customer: 'David Kim',
//     items: 3,
//     timeAgo: '45 minutes ago',
//     urgent: false,
//   },
// ];

// const WarehouseQueue = () => {
//   return (
//     <div className="warehouse-queue-page">
//       <Header />

//       <main className="main-content">
//         <div className="container">
//           <div className="page-header">
//             <div className="page-title-area">
//               <h1 className="page-title">Warehouse Queue</h1>
//             </div>
//             <button className="refresh-button">
//               <RiRefreshLine size={18} className="refresh-icon" />
//               Refresh
//             </button>
//           </div>

//           <div className="queue-list">
//             {mockQueueItems.map((item) => (
//               <Card key={item.id} className="queue-card">
//                 <div className="queue-card-content">
//                   <div className="queue-info">
//                     <div className="order-id-row">
//                       <h3 className="order-id">{item.id}</h3>
//                       <span
//                         className={`priority-badge ${item.priority.toLowerCase()}`}
//                       >
//                         {item.priority}
//                       </span>
//                       {item.tag && (
//                         <span className="tag-badge">{item.tag}</span>
//                       )}
//                     </div>

//                     <div className="meta-line">
//                       <span className="icon-label">👤</span>
//                       <span>{item.customer}</span>
//                     </div>
//                     <div className="meta-line">
//                       <span className="icon-label">📦</span>
//                       <span>{item.items} items</span>
//                     </div>
//                     <div className="meta-line">
//                       <span className="icon-label">🕒</span>
//                       <span className="time-ago">{item.timeAgo}</span>
//                     </div>
//                   </div>

//                   <button
//                     className={`start-fulfillment-btn ${
//                       item.urgent ? 'urgent' : ''
//                     }`}
//                   >
//                     Start Fulfillment
//                   </button>
//                 </div>
//               </Card>
//             ))}
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default WarehouseQueue;
// import React from 'react';
// import Header from '../components/Header';
// import Card from '../components/Card';
// import './WarehouseQueue.css';

// const mockQueueItems = [
//   {
//     id: '#WH-2024-001284',
//     priority: 'NORMAL',
//     tag: 'Express',
//     customer: 'Lisa Wang',
//     items: 9,
//     timeAgo: '4 hours ago',
//     urgent: false,
//   },
//   {
//     id: '#WH-2024-001289',
//     priority: 'URGENT',
//     tag: null,
//     customer: 'Michael Chen',
//     items: 14,
//     timeAgo: '1 hour ago',
//     urgent: true,
//   },
//   {
//     id: '#WH-2024-001301',
//     priority: 'NORMAL',
//     tag: null,
//     customer: 'Sarah Johnson',
//     items: 5,
//     timeAgo: '2 hours ago',
//     urgent: false,
//   },
//   {
//     id: '#WH-2024-001315',
//     priority: 'NORMAL',
//     tag: 'Express',
//     customer: 'David Kim',
//     items: 3,
//     timeAgo: '45 minutes ago',
//     urgent: false,
//   },
// ];

// const WarehouseQueue = () => {
//   return (
//     <div className="warehouse-queue-page">
//       <Header />

//       <main className="main-content">
//         <div className="container">
//           <div className="page-header">
//             <div className="page-title-area">
//               <h1 className="page-title">Warehouse Queue</h1>
//             </div>
//             <button className="refresh-button">
//               <span className="icon">↻</span> Refresh
//             </button>
//           </div>

//           <div className="queue-list">
//             {mockQueueItems.map((item) => (
//               <Card key={item.id} className="queue-card">
//                 <div className="queue-card-content">
//                   <div className="queue-info">
//                     <div className="order-id-row">
//                       <h3 className="order-id">{item.id}</h3>
//                       <span
//                         className={`priority-badge ${item.priority.toLowerCase()}`}
//                       >
//                         {item.priority}
//                       </span>
//                       {item.tag && (
//                         <span className="tag-badge">{item.tag}</span>
//                       )}
//                     </div>

//                     <div className="meta-line">
//                       <span className="icon-label">👤</span>
//                       <span>{item.customer}</span>
//                     </div>
//                     <div className="meta-line">
//                       <span className="icon-label">📦</span>
//                       <span>{item.items} items</span>
//                     </div>
//                     <div className="meta-line">
//                       <span className="icon-label">🕒</span>
//                       <span className="time-ago">{item.timeAgo}</span>
//                     </div>
//                   </div>

//                   <button
//                     className={`start-fulfillment-btn ${
//                       item.urgent ? 'urgent' : ''
//                     }`}
//                   >
//                     Start Fulfillment
//                   </button>
//                 </div>
//               </Card>
//             ))}
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default WarehouseQueue;